// extracted by mini-css-extract-plugin
export default {"container":"Collaborators_container__DNduP","content":"Collaborators_content__BcweD"};